import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'mrsoftapps-activity-modal',
  templateUrl: './activity-modal.component.html',
  styleUrls: ['./activity-modal.component.css'],
})
export class ActivityModalComponent implements OnInit {
  sortedItems: any[];

  constructor(
    public dialogRef: MatDialogRef<ActivityModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any
  ) {}

  ngOnInit() {
    if (this.modalData.projectActivities) {
      const newprojectActivities = Object.assign(
        [],
        this.modalData.projectActivities
      );
      this.sortedItems = newprojectActivities.sort(
        (a: any, b: any) =>
          new Date(b.dateCreated).getTime() - new Date(a.dateCreated).getTime()
      );
    }
  }

  closeModal() {
    this.dialogRef.close();
  }

  openCreateActivity() {
    this.dialogRef.close('openActivity');
  }
}
